// Hamburger menu
const erBtn = document.getElementById('erMenuBtn');
const erMenu = document.getElementById('erMobileMenu');
if (erBtn && erMenu) {
  erBtn.addEventListener('click', function () {
    erMenu.classList.toggle('open');
    erBtn.classList.toggle('open');
  });
}

// Sticky header shadow
const hdr = document.querySelector('.er-header');
if (hdr) {
  window.addEventListener('scroll', function () {
    hdr.style.boxShadow = window.scrollY > 8 ? '0 4px 20px rgba(66,133,244,.1)' : 'none';
  }, { passive: true });
}
